import { FC, PropsWithChildren } from "react";
import { HelmetProvider } from "react-helmet-async";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { appRoutes } from "router/routes";
import store from "store";

import BranchProvider from "./BranchProvider";
import BrazeProvider from "./BrazeProvider";
import { OAuthProvider } from "./OAuthProvider";
import { PlatformProvider } from "./PlatformProvider";
import RefreshTokenProvider from "./RefreshTokenProvider";
import StripeProvider from "./StripeProvider";

const router = createBrowserRouter(appRoutes);

export const Providers: FC<PropsWithChildren> = ({ children }) => (
  <HelmetProvider>
    <PlatformProvider store={store}>
      <OAuthProvider>
        <RefreshTokenProvider>
          <BranchProvider>
            <StripeProvider>
              <BrazeProvider>{children}</BrazeProvider>
            </StripeProvider>
          </BranchProvider>
        </RefreshTokenProvider>
      </OAuthProvider>
    </PlatformProvider>
  </HelmetProvider>
);

export const AppProvider: FC = () => <RouterProvider router={router} />;

export { default as BranchProvider } from "./BranchProvider";
export { default as BrazeProvider } from "./BrazeProvider";
export * from "./ModalsProvider";
export * from "./OAuthProvider";
export * from "./PlatformProvider";
export { default as RefreshTokenProvider } from "./RefreshTokenProvider";
export { default as StripeProvider } from "./StripeProvider";
